// @flow
import * as React from 'react'
import { Page } from 'framework'
import type { Nullable } from 'types'
import PageFooter from 'ui/PageFooter'
import { MarcomPageHeader } from 'ui/PageHeader'
import PageContent from './PageContent'
import { WhitelabelContext } from 'main/framework'

type Props = {
  title?: string,
  description?: string,
  schema?: {} | {}[],
  metatags: {}[],
  contentWidthConstraint: boolean,
  header?: Nullable<React.Node>,
  showConciergeCta: boolean,
  children: React.Node,
  urlPath?: string,
}

export default class PageShell extends React.Component<Props> {
  static contextType = WhitelabelContext
  static defaultProps = {
    contentWidthConstraint: true,
    metatags: [],
    showConciergeCta: false,
  }

  render = () => {
    const ContentContainer = this.props.contentWidthConstraint
      ? PageContent
      : NoContentWidthConstraint

    return (
      <Page
        title={this.props.title}
        description={this.props.description}
        schema={this.props.schema}
        metatags={this.props.metatags}
        urlPath={this.props.urlPath}
      >
        {this.renderHeaderMaybe()}
        <ContentContainer>{this.props.children}</ContentContainer>
        <PageFooter />
      </Page>
    )
  }

  renderHeaderMaybe = () => {
    if (this.props.header === null) return null
    if (this.props.header === undefined) {
      return (
        <MarcomPageHeader
          whitelabel={this.context}
          showConciergeCta={this.props.showConciergeCta}
        />
      )
    }

    return this.props.header
  }
}

type NoContentWidthConstraintProps = {
  children: React.Node,
}

function NoContentWidthConstraint({ children }: NoContentWidthConstraintProps) {
  return <div>{children}</div>
}
